module.exports = __webpack_public_path__ + "img/logo-dark.8b671ec9.svg";